import { Chip, Stack, Typography } from "@mui/material";
import React, { memo } from "react";

import type { DashboardTaskRowModel } from "../../utils/crmOperationalDashboard.aggregate";

export type DashboardTaskRowProps = {
  task: DashboardTaskRowModel;
};

const STATUS_COLOR = {
  DONE: "success",
  INPROGRESS: "warning",
  TODO: "primary",
} as const;

export const DashboardTaskRow = memo(({ task }: DashboardTaskRowProps) => {
  const statusKey = task.status === "DONE" ? "DONE" : task.status === "INPROGRESS" ? "INPROGRESS" : "TODO";

  return (
    <Stack spacing={0.75} sx={{ py: 1 }}>
      <Typography variant="body2" fontWeight={600} color={task.isUrgent ? "error.main" : "text.primary"}>
        {task.title}
      </Typography>
      <Stack direction="row" spacing={0.5} flexWrap="wrap" useFlexGap>
        <Chip size="small" label={task.assigneeName} variant="outlined" />
        <Chip size="small" label={`Due ${task.dueLabel}`} variant="outlined" />
        <Chip size="small" label={task.statusLabel} color={STATUS_COLOR[statusKey]} variant="outlined" />
        {task.priorityLabel ? (
          <Chip size="small" label={task.priorityLabel} variant="filled" sx={{ bgcolor: "action.selected" }} />
        ) : (
          <Chip size="small" label="Priority —" variant="outlined" sx={{ opacity: 0.7 }} />
        )}
      </Stack>
    </Stack>
  );
});

DashboardTaskRow.displayName = "DashboardTaskRow";
